<template>
  <section class="app-main">
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <!-- <transition name="fade-transform" mode="out-in"> -->
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    <!-- </transition> -->
  </section>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: 'AppMain',
  components: { Breadcrumb },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>


.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 98px);
  }

  .fixed-header+.app-main {
    padding-top: 98px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

.app-main > .main-common {
  height: calc(100vh - 128px);
  //margin: 10px;
  background: #fff;
  width: calc(100% - 20px);
  overflow: auto;
}

//.app-main>div>.main-common {
//  min-height: calc(100vh - 84px);
//  margin: 10px;
//  width: calc(100% - 20px);
//}
</style>
